import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const LoadSecuritySafeLoadingPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  transportManagerContact,
  safetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Load_Security_and_Safe_Loading_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Load Security and Safe Loading Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To ensure all loads carried by {clientName || "the Company"} are safely and securely loaded, restrained, and transported in compliance with all relevant legislation and industry best practices.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, subcontractors, and drivers involved in the loading, securing, and transportation of goods within the company’s operations.
      </p>

      <h4 className="section-title">3. Legal Framework</h4>
      <p className="section-content">
        {clientName || "The Company"} commits to complying with the Load Security Regulations 2004, the Health and Safety at Work Act 1974, and other applicable laws and codes of practice concerning load restraint and safe loading.
      </p>

      <h4 className="section-title">4. Responsibilities</h4>
      <ul>
        <li><strong>Transport Manager:</strong> Overall responsibility for ensuring policies and procedures are implemented and monitored. Contact: {transportManagerContact || "[Insert Contact]"}</li>
        <li><strong>Drivers:</strong> Responsible for performing walkaround checks to verify load security and reporting any defects or issues immediately.</li>
        <li><strong>Loaders:</strong> Ensure loads are properly secured using approved methods, equipment, and according to load type.</li>
        <li><strong>Safety Officer:</strong> Provides training and oversees compliance with safe loading standards. Contact: {safetyOfficerContact || "[Insert Contact]"}</li>
      </ul>

      <h4 className="section-title">5. Load Security Standards</h4>
      <ul>
        <li>Use appropriate load restraint equipment including straps, chains, netting, and tarpaulins.</li>
        <li>Check that loads are evenly distributed and stable to prevent shifting during transit.</li>
        <li>Ensure hazardous or dangerous goods are segregated and secured as per regulations.</li>
        <li>Conduct regular inspections of restraint equipment and replace damaged items promptly.</li>
      </ul>

      <h4 className="section-title">6. Safe Loading Procedures</h4>
      <ul>
        <li>Follow risk assessments and method statements before loading.</li>
        <li>Use mechanical aids and team lifting techniques to reduce manual handling risks.</li>
        <li>Ensure all personnel involved in loading are adequately trained and wear appropriate PPE.</li>
        <li>Keep loading areas clear of hazards and maintain good communication during operations.</li>
      </ul>

      <h4 className="section-title">7. Training and Competence</h4>
      <p className="section-content">
        {clientName || "The Company"} provides regular training on load security and safe loading practices for all relevant staff to maintain high standards and compliance.
      </p>

      <h4 className="section-title">8. Incident Reporting and Investigation</h4>
      <p className="section-content">
        Any incidents involving load shifts, spills, or accidents must be reported immediately and investigated to prevent recurrence.
      </p>

      <h4 className="section-title">9. Monitoring and Continuous Improvement</h4>
      <p className="section-content">
        Compliance with this policy will be monitored through audits, driver feedback, and spot checks. Improvements will be made based on findings and changes in legislation or technology.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Load Security and Safe Loading Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default LoadSecuritySafeLoadingPolicy;
